import { render } from "./TitleScreen.vue?vue&type=template&id=3e08b5d5&scoped=true"
import script from "./TitleScreen.vue?vue&type=script&lang=js"
export * from "./TitleScreen.vue?vue&type=script&lang=js"

import "./TitleScreen.vue?vue&type=style&index=0&id=3e08b5d5&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e08b5d5"]])

export default __exports__